import 'react-modern-calendar-datepicker/lib/DatePicker.css';
// import api from 'services/api';
// import { useDispatch } from 'react-redux';
// import { loadSpecificVideo } from 'store/videoSlice';

import { cursorMaker, videosCursorMaker } from 'utils/cursorMaker';
import { Calendar, utils } from 'react-modern-calendar-datepicker';
// import { useLocation } from 'react-router-dom';
// import { loadSpecificActivities } from 'store/activitySlice';
// import { isMobile } from 'react-device-detect';
// import { setUserChannelData, resetChannelState } from 'store/userActivitySlice';
// import { useEffect, useRef } from 'react';

interface IDatePicker {
  onCancel?: () => void;
  formatDate?: (date: Date) => void;
  activity: boolean;
  loadSpecificActivities: any;
  setShowMostRecent?: (value: any) => void;
}

export default function DatePicker(props: IDatePicker) {
  const { onCancel, activity = false, formatDate, loadSpecificActivities, setShowMostRecent } = props;
  // const location = useLocation();
  const handleChange = async (e: any) => {
    const selectedDate = [e.year, String(e.month).padStart(2, '0'), String(e.day).padStart(2, '0')].join('-');
    const timeFormat =
      ' 00:00:00' +
      (-new Date().getTimezoneOffset() > 0 ? '+' : '-') +
      String(Math.floor(Math.abs(new Date().getTimezoneOffset()) / 60)).padStart(2, '0') +
      ':' +
      String(new Date().getTimezoneOffset() % 60).padStart(2, '0');
    if (formatDate) {
      formatDate(new Date(selectedDate));
    } else {
      if (activity) {
        const cursor = cursorMaker(new Date(selectedDate + timeFormat), false);
        loadSpecificActivities(cursor);
      } else {
        // console.log('selectedDate', selectedDate);
        const date = new Date(selectedDate);
        date.setDate(date.getDate() + 1);
        const cursor = videosCursorMaker(new Date(date.toISOString().slice(0, 10) + timeFormat));
        loadSpecificActivities(cursor);
      }
      if (!activity && setShowMostRecent) {
        setShowMostRecent(true);
      }
      // flags?.setLoading(true);
      // const responseData = activity
      //   ? await api.get(
      //       `${
      //         channelId === 'home' ? 'api/users/vod-activities' : `api/channels/${channelId}/activities/`
      //       }?cursor=${window.btoa(requestData)}&page_size=${process.env.REACT_APP_PAGE_SIZE || 10}`
      //     )
      //   : await api.get(
      //       `${
      //         channelId === 'home' ? 'api/videos/recent-uploads/' : `api/videos/channel/${channelId}/vods/`
      //       }?cursor=${window.btoa(requestData)}&page_size=${process.env.REACT_APP_PAGE_SIZE || 10}`
      //     );
      // if (responseData.data.results.length > 0) {
      //   if (activity) {
      //     dispatch(resetChannelState({ channelId: channelId }));
      //     setTimeout(() => {
      //       dispatch(setUserChannelData({ channelId: channelId, data: responseData.data }));
      //       if (listRef) {
      //         listRef.scrollTo(100);
      //       }
      //       flags?.setLoading(false);
      //     }, 100);
      //   } else {
      //     console.log('load videos for channelId', channelId);
      //     // dispatch(loadSpecificVideo({ key: channelId, data: responseData.data }));
      //   }
      // const selectedId = activity ? responseData.data.results[0].event_id : responseData.data.results[0].event_id;
      // const divElement = document.getElementById(channelId + '-' + selectedId);
      // if (divElement) {
      //   divElement.scrollIntoView();
      //   if (isMobile) {
      //     const scrollAdjustment = 130;
      //     window.scrollBy(0, -scrollAdjustment);
      //   }
      // }
      // }
    }
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div className="transparent">
      <div className="relative border bg-gray-bg-dark border-gray-300 rounded-2xl bg-white py-5 px-7">
        <Calendar onChange={handleChange} maximumDate={utils('en').getToday()} shouldHighlightWeekends />
      </div>
    </div>
  );
}
